import styled from 'styled-components';

export const BaseTableStyled = styled.div<{ isInAdminPage?: boolean }>`
  .Polaris-IndexTable__TableRow {
    cursor: auto;
  }
  .estimate-table-container > span {
    display: block;
    width: fit-content;
  }
  .estimate-table-data {
    width: fit-content;
    border-bottom: 1px dotted rgba(0, 0, 0, 0.5);
    cursor: default;
  }
  .ellipsis-name {
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  @media (min-width: 768px) {
    .Polaris-IndexTable__ScrollBarContainer {
      display: none;
    }
  }
  .Polaris-IndexTable__IndexTableWrapperWithBulkActions {
    padding-bottom: 0 !important;
  }
  .Polaris-IndexTable__SelectAllActionsWrapper {
    padding-top: 0.7rem;
    padding-bottom: 0.7rem;
    border-width: 0 1px;
    border-color: rgb(211, 211, 211);
    border-style: solid;
  }
  .Polaris-IndexTable__BulkActionsWrapperSticky {
    position: absolute;
    bottom: unset;
  }
  .Polaris-InlineStack {
    --pc-inline-stack-gap-xs: var(--p-space-100) !important;
  }
  .Polaris-IndexTable__BulkActionsWrapper {
    top: 0;
    margin-top: ${(props) => (props.isInAdminPage ? '8px' : '0')};
    inset-block-start: 0 !important;
    inset-inline-start: 0 !important;
    .Polaris-BulkActions__Group.Polaris-BulkActions--groupNotSticky {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .Polaris-BulkActions__Group.Polaris-BulkActions__Group--entered {
      justify-content: flex-end;
    }
    .Polaris-BulkActions__ButtonGroupWrapper {
      padding: 0;
      margin: 0;
      border: none;
      outline: none;
      box-shadow: unset;
      &::before {
        position: unset;
      }
      .Polaris-BulkActions__BulkActionButton {
        .Polaris-Button.Polaris-Button--sizeSlim {
          background-color: white;
          padding: 0 !important;
          .Polaris-Button__Content {
            border-radius: 8px;
            border: 1px solid #bfbfbf;
            padding: 2px 6px;
          }
          .Polaris-Button__Text {
            font-size: 0.75rem;
          }
        }
        &:last-child {
          .Polaris-Button__Content {
            padding: 0 !important;
            border: none !important;
          }
          .Polaris-Button.Polaris-Button--sizeSlim {
            svg {
              fill: var(--p-color-icon-critical);
            }
          }
          .Polaris-Button.Polaris-Button--pressable.Polaris-Button--sizeMicro {
            padding: 0 !important;
            box-shadow: none !important;
            .Polaris-Icon > svg {
              fill: var(--p-color-icon-critical) !important;
              &:hover {
                fill: var(--p-color-text-critical-secondary) !important;
              }
            }
          }
        }
      }
    }

    .Polaris-BulkActions__BulkActionsPromotedActionsWrapper {
      .Polaris-BulkActions__BulkActionButton {
        &:last-child {
          .Polaris-Button.Polaris-Button--pressable.Polaris-Button--sizeMicro {
            padding: 0 !important;
            box-shadow: none !important;
            .Polaris-Icon > svg {
              fill: var(--p-color-icon-critical) !important;
              &:hover {
                fill: var(--p-color-text-critical-secondary) !important;
              }
            }
          }
        }
      }
    }

    .Polaris-BulkActions__BulkActionsPromotedActionsWrapper {
      .Polaris-BulkActions__BulkActionButton {
        &:last-child {
          .Polaris-Button.Polaris-Button--pressable.Polaris-Button--sizeMicro {
            padding: 0 !important;
            box-shadow: none !important;
            .Polaris-Icon > svg {
              fill: var(--p-color-icon-critical) !important;
              &:hover {
                fill: var(--p-color-text-critical-secondary) !important;
              }
            }
          }
        }
      }
    }
  }
`;
